import React, { ChangeEvent, FormEvent, useState } from 'react';

import SendIcon from '../assets/icons/send.svg';
import { MessageSender } from '../types/shared';

export interface InputProps extends MessageSender {
  chatId: string;
}

function Input({ chatId, sendMessage }: InputProps): JSX.Element {
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (!submitting) {
      setMessage(event.target.value);
    }
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    // CHAT-190: bugfix to re-focus input box in IE11 on submit
    if (inputRef.current) {
      inputRef.current.focus();
    }

    if (!submitting) {
      setSubmitting(true);

      sendMessage({
        variables: {
          id: chatId,
          textBody: message,
        },
      })
        .then(() => {
          setMessage('');
          setSubmitting(false);
        })
        .catch(() => setSubmitting(false));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="Input-area">
      <input
        className="Input-window"
        type="text"
        onChange={handleChange}
        value={message}
        disabled={false}
        data-testid="chat-input"
        ref={inputRef}
        aria-label="chat input field"
        placeholder="Enter your question"
      />
      <button type="submit" data-testid="submit-button" aria-label="submit chat input">
        <img src={SendIcon} alt="send icon" className="send-icon" />
      </button>
    </form>
  );
}

export default Input;
